<template>
  <card-form
    :collapsed="!isExamCollapsed"
    class="exam__container exam-additional exam-item"
  >
    <div
      slot="expanded"
      class="form-container"
    >
      <md-layout
        :md-gutter="24"
        md-flex="100"
      >
        <md-layout md-flex="15">
          <md-input-container
            id="patientIdLis"
            :class="{ 'md-input-invalid': errors.has('idExamCode') }"
          >
            <label>Código do Exame</label>
            <md-input
              id="txtNewExamCode"
              v-model="item.details.code"
              name="idExamCode"
              type="text"
              title=""
              disabled
              placeholder="Código do Exame"
            />
          </md-input-container>
        </md-layout>
        <md-layout md-flex="20">
          <md-input-container
            id="patientName"
            :class="{ 'md-input-invalid': errors.has('examName') }"
          >
            <label>Nome do Exame</label>
            <md-input
              id="txtNewExamName"
              v-model="item.details.name"
              name="examName"
              type="text"
              title=""
              disabled
              placeholder="Nome do Exame"
            />
          </md-input-container>
        </md-layout>
        <md-layout md-flex="20">
          <md-input-container
            id="examMaterial"
            class="md-advanced-select md-input-placeholder md-has-value"
            :class="{
              'md-input-invalid': errors.has('material'),
            }"
          >
            <label>Material</label>
            <div class="advanced-select__container">
              <model-list-select
                :id="'cboNewMaterial'"
                v-model="material"
                v-validate="'required'"
                label="label"
                placeholder="Selecione..."
                :options="getAvailableMaterials()"
                name="material"
              >
                <span slot="no-options">
                  <p class="v-select-no-matching">
                    Desculpe, não foram encontrados materiais para essa pesquisa.
                  </p>
                </span>
              </model-list-select>
            </div>
            <span class="md-error">Obrigatório</span>
          </md-input-container>
        </md-layout>
        <md-layout md-flex="10">
          <md-input-container :class="{ 'md-input-invalid': errors.has('samples') }">
            <label class="dont-wrap">Qtd. Amostras</label>
            <md-input
              id="txtNewSampleQuantity"
              v-model="amount"
              v-validate="'required|min_value:1'"
              v-mask="'###'"
              name="samples"
              maxlength="3"
              data-vv-validate-on="none"
              type="text"
              title=""
              placeholder="Amostras"
              @keydown.enter.native="focusNextField('txtNewAddExamNote')"
            />
            <span
              v-if="errors.firstByRule('samples', 'required')"
              class="md-error"
            >
              Obrigatório
            </span>
            <span
              v-else-if="errors.firstByRule('samples', 'min_value')"
              class="md-error"
            >
              Valor inválido
            </span>
          </md-input-container>
        </md-layout>
        <md-layout
          v-if="item.details.deadline?.trim()"
          md-flex="15"
        >
          <md-input-container id="deadline">
            <label>Prazo de execução</label>
            <md-input
              id="txtDeadline"
              v-model="item.details.deadline"
              name="deadline"
              type="text"
              disabled
              placeholder="Prazo de execução"
            />
          </md-input-container>
        </md-layout>
        <md-layout
          v-if="item.details.minimumVolume?.trim()"
          md-flex="15"
        >
          <md-input-container id="minimumVolume">
            <label>Volume</label>
            <md-input
              id="txtMinimumVolume"
              v-model="item.details.minimumVolume"
              name="minimumVolume"
              type="text"
              disabled
              placeholder="Volume"
            />
          </md-input-container>
        </md-layout>
        <md-layout md-flex="15">
          <md-input-container
            id="conditioning"
            :class="{ 'md-input-invalid': errors.has('conditioning') }"
          >
            <label>Acondicionamento</label>
            <md-input
              id="txtNewConditioning"
              v-model="conditioning"
              name="conditioning"
              type="text"
              title=""
              disabled
              value="Acondicionamento"
              placeholder="Acondicionamento"
            />
          </md-input-container>
        </md-layout>
      </md-layout>

      <!-- DYNAMIC FIELDS -->
      <md-layout
        :md-gutter="24"
        md-flex="100"
        class="additional-fields"
      >
        <md-layout
          v-for="(additionalField, idx) in additionalFieldNewValue"
          :key="additionalField.id"
          md-flex="33"
        >
          <md-input-container
            v-if="additionalField.type === 'SELECT'"
            :id="additionalField.id"
            :class="{
              'md-input-placeholder md-advanced-select': true,
              'md-has-value': additionalFieldValues[idx],
              'md-input-invalid': errors.has('additionalField_' + idx),
            }"
          >
            <label>{{ additionalField.name }} *</label>
            <div class="advanced-select__container">
              <multiselect
                :id="'additionalField_' + idx"
                v-model="additionalFieldValues[idx]"
                v-validate="additionalField.required ? 'required|' : ''"
                :name="'additionalField_' + idx"
                :show-labels="false"
                :hide-selected="false"
                placeholder
                :options="additionalField.options"
                @keydown.enter.native.stop="enter"
              />
              <md-input type="hidden" />
            </div>
            <span
              v-if="errors.firstByRule('additionalField_' + idx, 'required')"
              class="md-error"
            >
              Obrigatório
            </span>
          </md-input-container>

          <v-date-picker
            v-if="additionalField.type === 'DATA'"
            v-model="additionalFieldValues[idx]"
            v-validate="
              'required|check_date_format:DD/MM/YYYY|not_future_date|after_date:31/12/1899'
            "
            v-mask="'##/##/####'"
            :tint-color="'#7f1a54'"
            :pane-width="290"
            mode="single"
            data-vv-validate-on="none"
            maxlength="10"
            style="width: 100%"
            :name="'additionalField_' + idx"
          >
            <md-input-container
              :id="'additionalField_' + idx"
              slot-scope="{ inputValue, updateValue }"
              :class="{ 'md-input-invalid': errors.has('additionalField_' + idx) }"
            >
              <label>{{ additionalField.name }} *</label>
              <md-input
                :id="'additionalField_' + idx"
                type="text"
                :value="inputValue"
                :placeholder="additionalField.name + ' *'"
                @change.native="updateValue($event.target.value)"
              />
              <md-icon>date_range</md-icon>
              <span
                v-if="errors.firstByRule('additionalField_' + idx, 'required')"
                class="md-error"
              >
                Obrigatório
              </span>
              <span
                v-else-if="
                  errors.firstByRule('additionalField_' + idx, 'check_date_format')
                "
                class="md-error"
              >
                Valor inválido
              </span>
              <span
                v-else-if="
                  errors.firstByRule('additionalField_' + idx, 'not_future_date')
                "
                class="md-error"
              >
                Data não pode ser maior que a atual
              </span>
              <span
                v-else-if="errors.firstByRule('additionalField_' + idx, 'after_date')"
                class="md-error"
              >
                Ano deve ser maior que 1899
              </span>
            </md-input-container>
          </v-date-picker>

          <md-input-container
            v-if="additionalField.type === 'DECIMAL'"
            :id="additionalField.id"
            class="exam-item__unity"
            :class="{ 'md-input-invalid': errors.has('additionalField_' + idx) }"
          >
            <label>
              {{
                additionalField.name +
                (additionalField.name === 'Altura'
                  ? '(cm)'
                  : additionalField.name === 'Peso'
                    ? '(kilos)'
                    : '')
              }}
              *
            </label>
            <template
              v-if="
                additionalField.name === 'Altura' ||
                additionalField.name === 'Volume' ||
                additionalField.name === 'Peso'
              "
            >
              <md-input
                :id="'additionalField_' + idx"
                v-model="additionalFieldValues[idx]"
                v-mask="'###################'"
                v-validate="
                  (additionalField.required ? 'required|' : '') +
                  $strings.additionalFieldTypeMask[additionalField.type]
                "
                type="text"
                :name="'additionalField_' + idx"
                :maxlength="additionalField.max_len"
                :title="getAdditionalFieldTooltip(additionalField)"
                data-vv-validate-on="none"
                :placeholder="
                  additionalField.name +
                  (additionalField.name === 'Altura'
                    ? '(cm)'
                    : additionalField.name === 'Peso'
                      ? '(kilos)'
                      : '') +
                  ' *'
                "
              />
            </template>
            <template v-else>
              <md-input
                :id="'additionalField_' + idx"
                v-model="additionalFieldValues[idx]"
                v-validate="
                  (additionalField.required ? 'required|' : '') +
                  $strings.additionalFieldTypeMask[additionalField.type]
                "
                type="text"
                :name="'additionalField_' + idx"
                :maxlength="additionalField.max_len"
                :title="getAdditionalFieldTooltip(additionalField)"
                data-vv-validate-on="none"
                :placeholder="additionalField.name + ' *'"
              />
              <span
                v-if="errors.firstByRule('additionalField_' + idx, 'required')"
                class="md-error"
              >
                Obrigatório
              </span>
              <span
                v-else-if="
                  errors.firstByRule(
                    'additionalField_' + idx,
                    $strings.additionalFieldTypeToValidation.TEXT ==
                      $strings.additionalFieldTypeToValidation[additionalField.type]
                      ? 'regex'
                      : $strings.additionalFieldTypeToValidation[additionalField.type]
                  )
                "
                class="md-error"
              >
                Valor inválido
              </span>
            </template>
          </md-input-container>
        </md-layout>
      </md-layout>

      <md-layout
        :md-gutter="24"
        md-flex="100"
      >
        <md-layout md-flex="50">
          <md-input-container id="examComments">
            <label>Observação</label>
            <div
              class="orders-new__observation-container"
              @keydown.enter.capture="preventRawEnterFromPropagation"
            >
              <md-textarea
                id="txtNewAddExamNote"
                v-model="notes"
                v-validate=""
                maxlength="250"
                type="text"
                name="exam.comments"
                title=""
                placeholder="Observação"
                @keydown.enter.native="focusNextField('btnNewSubmitExam')"
              />
            </div>
          </md-input-container>
        </md-layout>
        <md-layout
          md-flex="15"
          class="exam-item__details"
        >
          <div class="exam-item__details-anchor">
            <md-icon
              md-src="/static/images/icon-info.svg"
              class="exam-item__details-icon"
            />
            <a
              id="txtNewExamDetails"
              tabindex="-1"
              :href="$strings.url + '/detalhes?mnemonic=' + item.details.code"
              target="_blank"
              class="exam-item__details-anchor__text"
            >
              Detalhes do Exame
            </a>
          </div>
        </md-layout>
        <md-layout
          md-flex="15"
          class="exam-item__details priority"
        >
          <div v-if="item.details.allowUrgent && allowExamUrgent">
            <md-switch
              v-if="item.details.nobleMaterial === false"
              id="priorityUrgent"
              v-model="urgent"
              name="urgent"
              class="md-primary"
            >
              Urgente
            </md-switch>
          </div>
          <p v-if="item.details.nobleMaterial && !item.details.allowUrgent">
            Este é um material nobre
          </p>
        </md-layout>
        <md-layout md-flex="20">
          <md-button
            v-if="item.details.code !== 'SEXA'"
            id="btnNewSubmitExam"
            class="btn btn-primary orders-new__patient__submit-button submit-button"
            @click="validateBeforeSubmit"
            @keydown.enter.native="validateBeforeSubmit"
          >
            OK
          </md-button>
        </md-layout>
        <md-layout
          v-if="item.details.code === 'SEXA'"
          class="warning-exam"
          md-flex="100"
        >
          <md-layout md-flex="80">
            <p>
              <md-icon
                md-src="/static/images/icon-info.svg"
                class="exam-item__details-icon"
              />
              Este exame requer o preenchimento de um termo de responsabilidade que será
              disponibilizado ao transferir a OS.
            </p>
          </md-layout>
          <md-layout md-flex="20">
            <md-button
              id="btnNewSubmitExam"
              class="btn btn-primary orders-new__patient__submit-button submit-button"
              @click="validateBeforeSubmit"
              @keydown.enter.native="validateBeforeSubmit"
            >
              OK
            </md-button>
          </md-layout>
        </md-layout>
      </md-layout>

      <md-button
        v-if="!disableDeletion"
        class="md-icon-button card-form__delete-button"
        @click="deleteOrderExams(item)"
      >
        <md-icon class="card-form__delete-button-icon icon-delete-alt" />
        <md-tooltip
          md-delay="400"
          md-direction="top"
        >
          Excluir exame
        </md-tooltip>
      </md-button>
    </div>

    <md-layout
      slot="collapsed"
      class="collapsed-container card-form--collapsed"
      :md-gutter="24"
      md-flex="100"
      @click.native="editExam(item)"
    >
      <md-layout
        class="collapsed__item"
        md-flex="15"
      >
        <div class="md-input-container md-theme-default">
          <h3>Código do Exame</h3>
          <p :title="item.details.code">
            {{ item.details.code }}
          </p>
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="20"
      >
        <div class="md-input-container md-theme-default">
          <h3>Nome do Exame</h3>
          <p :title="item.details.name">
            {{ item.details.name }}
          </p>
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="20"
      >
        <div class="md-input-container md-theme-default">
          <h3>Material</h3>
          <p
            class="material"
            :title="materialName"
          >
            {{ materialId }} - {{ materialName }}
          </p>
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="10"
      >
        <div class="md-input-container md-theme-default">
          <h3 class="dont-wrap">Qtd. Amostras</h3>
          <p>{{ amount }}</p>
        </div>
      </md-layout>
      <md-layout
        v-if="item.details.deadline?.trim()"
        class="collapsed__item"
        md-flex="15"
      >
        <div class="md-input-container md-theme-default">
          <h3>Prazo de execução</h3>
          <p :title="item.details.deadline">
            {{ item.details.deadline }}
          </p>
        </div>
      </md-layout>
      <md-layout
        v-if="item.details.minimumVolume?.trim()"
        class="collapsed__item"
        md-flex="15"
      >
        <div class="md-input-container md-theme-default">
          <h3>Volume</h3>
          <p :title="item.details.minimumVolume">
            {{ item.details.minimumVolume }}
          </p>
        </div>
      </md-layout>
      <p
        id="btnNewEditExam"
        class="collapsed__list__item__edit-button"
        :class="{ 'collapsed__list__item__delete-button': disableDeletion }"
        @click="editExam(item)"
      >
        <md-icon class="collapsed__list__item__edit-button__icon icon-edit-alt" />
        <md-tooltip
          md-delay="400"
          md-direction="top"
        >
          Editar exame
        </md-tooltip>
      </p>
      <p
        v-if="!disableDeletion"
        id="btnNewDeleteExam"
        class="collapsed__list__item__delete-button"
        @click.prevent="deleteOrderExams(item)"
      >
        <md-icon class="card-form__delete-button-icon icon-delete-alt" />
        <md-tooltip
          md-delay="400"
          md-direction="top"
        >
          Excluir exame
        </md-tooltip>
      </p>
    </md-layout>
  </card-form>
</template>

<script>
import mixin from './examMixin'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import Moment from 'moment'

export default {
  name: 'AdditionalExam',
  components: {
    multiselect: Multiselect,
  },
  mixins: [mixin],
  data: () => {
    return {
      additionalFieldValues: [],
    }
  },
  computed: {
    ...mapGetters(['allowExamUrgent']),
    additionalFieldNewValue() {
      return this.item.details.fields.map(item => {
        if (item.name === 'FertilizacaoInVitro') {
          return {
            ...item,
            type: 'SELECT',
            options: ['Sim', 'Não'],
          }
        }
        if (item.name === 'DataUltimaMenstruacao') {
          return {
            ...item,
            type: 'DATA',
          }
        }
        return item
      })
    },
    material: {
      get: function () {
        if (
          !this.item ||
          !this.item.details ||
          !this.item.details.materials ||
          !this.item.sample.material
        ) {
          return null
        }

        // Busca na lista de materiais disponiveis
        // aquele que possui o mesmo id do item da store
        for (let i = 0; i < this.item.details.materials.length; i++) {
          let element = this.item.details.materials[i]
          if (element.id === this.item.sample.material) {
            return element
          }
        }
      },
      set: function (value) {
        if (JSON.stringify(value).length > 2) {
          this.updateExam({
            raw: this.item,
            id: this.item.id,
            code_origin_lis: this.item.code_origin_lis,
            material: !value ? 0 : value.id,
            amount: this.item.sample.amount,
            notes: this.item.notes,
            additionalFieldValues: this.item.additional_field_values,
            urgent: this.item.urgent,
          })
        }
      },
    },
    amount: {
      get: function () {
        if (!this.item || !this.item.sample) {
          return 0
        }
        return this.item.sample.amount
      },
      set: function (value) {
        if (!this.item) {
          return
        }

        this.updateExam({
          raw: this.item,
          id: this.item.id,
          code_origin_lis: this.item.code_origin_lis,
          material: this.item.sample.material,
          amount: value,
          notes: this.item.notes,
          additionalFieldValues: this.item.additional_field_values,
          urgent: this.item.urgent,
        })
      },
    },
    notes: {
      get: function () {
        if (!this.item) {
          return ''
        }
        return this.item.notes
      },
      set: function (value) {
        if (!this.item || !this.item.sample) {
          return
        }

        this.updateExam({
          raw: this.item,
          id: this.item.id,
          code_origin_lis: this.item.code_origin_lis,
          material: this.item.sample.material,
          amount: this.item.sample.amount,
          notes: value,
          additionalFieldValues: this.item.additional_field_values,
          urgent: this.item.urgent,
        })
      },
    },
    urgent: {
      get: function () {
        if (!this.item) {
          return ''
        }
        return this.item.urgent
      },
      set: function (value) {
        if (!this.item || !this.item.sample) {
          return
        }

        this.updateExam({
          raw: this.item,
          id: this.item.id,
          code_origin_lis: this.item.code_origin_lis,
          material: this.item.sample.material,
          amount: this.item.sample.amount,
          notes: this.item.notes,
          additionalFieldValues: this.item.additional_field_values,
          urgent: value,
        })
      },
    },
  },
  watch: {
    additionalFieldValues: function () {
      this.updateExam({
        raw: this.item,
        id: this.item.id,
        code_origin_lis: this.item.code_origin_lis,
        material: this.item.sample.material,
        amount: this.item.sample.amount,
        notes: this.item.notes,
        urgent: this.item.urgent,
        additionalFieldValues: this.mountAdditionalFieldsForStore(),
      })
    },
  },
  mounted() {
    this.materialOptions = this.item.details.materials.map(function (item) {
      return { label: item.name, value: item.name }
    })
    this.analyticsSuccessInsertingExam(this.item.details.id)

    for (let i = 0; i < this.item.details.fields.length; i++) {
      if (this.item.additional_field_values) {
        if (this.item.additional_field_values[i].value === undefined) {
          this.additionalFieldValues.push(this.item.additional_field_values[i].value)
        } else {
          const dateFormat =
            this.item.additional_field_values[i].value.toString().split('/').length === 3
              ? new Date(
                  Moment(
                    this.item.additional_field_values[i].value,
                    'DD-MM-YYYY'
                  ).format()
                )
              : this.item.additional_field_values[i].value
          this.additionalFieldValues.push(dateFormat)
        }
      } else {
        this.additionalFieldValues.push(null)
      }
    }
    let self = this
    Vue.nextTick(function () {
      self.validateOnMount()
    })
  },
  methods: {
    getAdditionalFieldTooltip(additionalField) {
      let tooltip = additionalField.name
      if (additionalField.unit_measurement) {
        tooltip = tooltip + ' (' + additionalField.unit_measurement + ')'
      }
      return tooltip
    },
    mountAdditionalFieldsForStore() {
      let elements = []
      for (let i = 0; i < this.item.details.fields.length; i++) {
        let el = this.item.details.fields[i]
        elements.push({
          id: el.id,
          value: this.additionalFieldValues[i] ? this.additionalFieldValues[i] : '',
        })
      }
      return elements
    },
    focusNextField(id) {
      document.getElementById(id).focus()
    },
  },
}
</script>

<style lang="scss">
@import '../../../../static/stylesheets/mixins';
@import '../../../../static/stylesheets/components/orders/common-exam';

.additional-fields {
  .md-flex-33:nth-child(3n) {
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      /* IE10 & IE11 CSS styles go here */
      flex: 0 1 24.8%;
      padding-right: 0;
      min-width: 20%;

      @include breakpoint(medium) {
        flex: 0 1 25.8%;
      }

      @include breakpoint(big) {
        flex: 0 1 26.8%;
      }
    }
  }
}

.warning-exam {
  margin-top: 27px;

  p {
    font-size: 13px;
    color: #5a5a5a;
    display: flex;
    align-items: center;
  }

  .md-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .submit-button {
    margin: 0 0 auto auto;
  }
}
</style>
